import get from 'lodash/get';
import { getOauthPartnerId } from 'src/common/utils/queryParams';

export default function findPartnerInfo(query, partners) {
  return get(partners, getOauthPartnerId(query), {});
}
